<template>
  <b-input-group>
    <b-button variant="primary" v-b-modal.email-form>Email Files</b-button>

    <b-modal
      hide-footer
      id="email-form"
      ref="email-form"
      title="Email"
      ok-title="Send"
    >
      <label>Recipients</label>
      <b-form-input
        v-if="noEmails"
        v-model="email_recipients"
      ></b-form-input>
      <b-list-group v-if="hasEmails">
        <li v-for="email in emails">
          <b-list-group-item>
            <b-form-checkbox @input="add_recipient(email.email)">
              ({{ email.label }}) {{ email.email }}
            </b-form-checkbox>
          </b-list-group-item>
        </li>
      </b-list-group>

      <div v-if="hasEmails">
        <label>Additional Recipients</label>
        <b-form-input v-model="additional_email_recipients"></b-form-input>
      </div>

      <label>From</label>
      <b-form-input v-bind:value="email_source" readonly></b-form-input>

      <label>Subject</label>
      <b-form-input v-model="email_subject"></b-form-input>

      <label>Message</label>
      <b-form-textarea v-model="email_message" rows="10"> </b-form-textarea>

      <p>
        Links To Include: (Only those that are currently saved will appear here)
      </p>
      <b-list-group>
        <li v-for="file in files">
          <b-list-group-item>
            <b-form-checkbox @input="add_file(file)">
              <a :href="`${file.file}`" target="_blank">{{ file.name }}</a>
            </b-form-checkbox>
          </b-list-group-item>
        </li>
      </b-list-group>

      <b-button class="footer-button" @click="hideModal">Cancel</b-button>
      <b-button class="footer-button" variant="primary" @click="send_email"
        >Send</b-button
      >
    </b-modal>

    <b-toast id="toast-error-no-recipient" solid variant="danger">
      <div class="d-flex flex-grow-1 align-items-baseline" slot="toast-title">
        <strong class="mr-auto">Error</strong>
      </div>
      Unable to send email. You have no mail recipients.
    </b-toast>

    <b-toast id="toast-error-no-sender" solid variant="danger">
      <div class="d-flex flex-grow-1 align-items-baseline" slot="toast-title">
        <strong class="mr-auto">Error</strong>
      </div>
      Unable to send email. You have no email assigned to your account.
    </b-toast>

    <b-toast id="toast-error-no-subject" solid variant="danger">
      <div class="d-flex flex-grow-1 align-items-baseline" slot="toast-title">
        <strong class="mr-auto">Error</strong>
      </div>
      Unable to send email. You have no email subject.
    </b-toast>

    <b-toast id="toast-error-no-message" solid variant="danger">
      <div class="d-flex flex-grow-1 align-items-baseline" slot="toast-title">
        <strong class="mr-auto">Error</strong>
      </div>
      Unable to send email. You have no email message.
    </b-toast>

    <b-toast id="toast-error" solid variant="danger">
      <div class="d-flex flex-grow-1 align-items-baseline" slot="toast-title">
        <strong class="mr-auto">Error</strong>
      </div>
      Unable to send email.
    </b-toast>

    <b-toast id="toast-success" solid variant="success">
      <div class="d-flex flex-grow-1 align-items-baseline" slot="toast-title">
        <strong class="mr-auto">Success</strong>
      </div>
      Message was sent.
    </b-toast>
  </b-input-group>
</template>

<style>
.footer-button {
  margin: 3px;
  margin-top: 30px;
  float: right;
}

li {
  list-style-type: none;
}
</style>

<script>
import store from "../store";

export default {
  name: "EmailFiles",
  components: {},
  mixins: [],
  props: {
    parentType: { type: String, default: null },
    parentId: { type: Number, default: null },
    emails: { type: Array, default: null },
  },
  computed: {
    hasEmails() {
      return Array.isArray(this.emails) && this.emails.length > 0;
    },
    noEmails() {
      return !Array.isArray(this.emails) || this.emails.length === 0;
    }
  },
  data: () => {
    return {
      email_recipients: "",
      additional_email_recipients: "",
      email_source: "admin+shojun@ocom.com.au",
      email_subject: "",
      email_message: "",
      files: [],
      included_files: [],
      request: {
        to: "test@gmail.com",
        from: "admin+shojun@ocom.com.au",
        subject: "subject",
        body: "body",
        links: [],
      },
    };
  },
  methods: {
    hideModal() {
      this.$refs["email-form"].hide();
    },

    add_recipient(email) {
      if (this.email_recipients === "") {
        this.email_recipients = email;
      } else {
        this.email_recipients += ", " + email;
      }
    },

    add_file(file) {
      if (this.included_files.includes(file)) {
        // Remove
        this.included_files.splice(this.included_files.indexOf(file), 1);
      } else {
        // Add
        this.included_files.push(file);
      }
    },

    send_email() {
      var mailing_list = "";

      var recipients = this.email_recipients.split(" ");
      var additional_recipients = this.additional_email_recipients.split(" ");
      recipients.forEach(function (recipient) {
        if (mailing_list === "") {
          mailing_list = recipient;
        } else {
          mailing_list += ", " + recipient;
        }
      });
      additional_recipients.forEach(function (recipient) {
        if (mailing_list === "") {
          mailing_list = recipient;
        } else {
          mailing_list += ", " + recipient;
        }
      });

      if (mailing_list.trim() === "") {
        this.$bvToast.show("toast-error-no-recipient");
        return;
      }

      if (this.email_source.trim() === "") {
        this.$bvToast.show("toast-error-no-sender");
        return;
      }

      if (this.email_subject.trim() === "") {
        this.$bvToast.show("toast-error-no-subject");
        return;
      }

      if (this.email_message.trim() === "") {
        this.$bvToast.show("toast-error-no-message");
        return;
      }

      var data = {
        to: this.email_recipients,
        from: this.email_source,
        subject: this.email_subject,
        body: this.email_message,
        links: this.included_files,
      };

      store.dispatch("send_email", data).then(() => {
        this.$bvToast.show("toast-success");
        this.additional_email_recipients = "";
        this.email_recipients = ""
        this.email_subject = "";
        this.email_message = ""
      }).catch((error) => {
        this.$bvToast.show("toast-error");
        console.error(error);
      });
    },
  },

  watch: {
    parentId: function () {
      var parent = {
        parent_id: this.parentId,
        parent_type: this.parentType,
      };
      store.dispatch("get_files", parent).then(() => {
        this.files = store.getters.files;
      });
    },
  },
};
</script>
